import { webFonts } from "@/utils/fonts";
import { tabProps } from "@/utils/globalPropsTypes";
import { Form, Input } from "antd";
import ImageResize from "quill-image-resize-module-react";
import React from "react";
import ReactQuill, { Quill } from "react-quill-new";

window.Quill = Quill;
const Font = Quill.import("formats/font");
Font.whitelist = webFonts;
Quill.register(Font, true);

Quill.register("modules/imageResize", ImageResize, true);

const Size = Quill.import("formats/size");
Size.whitelist = [false, ...Array.from({ length: 101 }, (_, i) => `${i}px`)];
Quill.register(Size, true);

function EditorTab({ editItem }) {
  const { component } = editItem;

  return (
    <>
      {["textBox"].includes(component) && (
        <Form.Item name="description" label="Description">
          <ReactQuill modules={descriptionModules} theme="snow" />
        </Form.Item>
      )}

      {["html"].includes(component) && (
        <Form.Item name="description" label="Description">
          <Input.TextArea placeholder="Custom HTML" rows={5} />
        </Form.Item>
      )}
    </>
  );
}

export default EditorTab;

const descriptionModules = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ size: Size.whitelist }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    // [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    // [{ direction: "rtl" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
  imageResize: {
    // parchment: Parchment,
    modules: ["Resize", "DisplaySize"],
  },
  clipboard: {
    matchVisual: false,
  },
};

EditorTab.propTypes = tabProps;
